/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import countries from '@/services/country.json';
import allCountries from './phoneCodeList.json';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import {
  mapGetters
} from 'vuex';
export default {
  name: 'update-employee-form',
  components: {
    datetime: Datetime,
  },
  props: [],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organization:'',
      division:'',
      area_of_work:'',
      department:'',
      designation:'',
      countryList: [],
      country:'',
      city:'',
      allCountriesList:[],
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      userFilter:'',
      name_prefix:'Please Select',
      name_prefix_updated:'',
      prefix_dr_specialties:'',
      userFilter:'',
      accept_terms:'',
      other_doctor_cat:'',
      enabled_other_d_cat:false,
      professional_category:'',
      countryPrint:'',
      areaOfSpecialization:'',
      phoneNumber:{
        fullOTP:''
      },
      memberAllFilterList:{},
      memberAllFilterListResults:[],
      extraSubCatState:[],
      userRole:'',
      employeeUseInfo:null,
      change_date:''
    }
  },
  computed: {
    ...mapGetters([
      'orgUserDetailsByIdGetters'
    ]),
    getUserInfoByIdFun() {
      this.employeeUseInfo = this.$store.getters.orgUserDetailsByIdGetters.data
      return
    },
     SetIntialStatus() {
      if(this.employeeUseInfo){
        this.first_name = this.employeeUseInfo.first_name
        this.last_name = this.employeeUseInfo.last_name
        this.name_prefix = this.employeeUseInfo.salutation ||  'Please Select'
        this.name_prefix_updated = this.employeeUseInfo.salutation || ''
        this.email = this.employeeUseInfo.email
        this.area_of_work = this.employeeUseInfo.profile.area_of_work
        this.department = this.employeeUseInfo.profile.department
        this.designation = this.employeeUseInfo.profile.designation
        this.division = this.employeeUseInfo.profile.division
        this.country = this.employeeUseInfo.profile.country.toLowerCase() || ''
        this.city = this.employeeUseInfo.profile.city
        this.activeStatus = this.employeeUseInfo.is_active
        this.userRole = this.employeeUseInfo.user_type || ''
        this.phone.countryCode = this.employeeUseInfo.profile.mobile_country_code  || '+91'
        this.phone.number = this.employeeUseInfo.profile.mobile
        this.professional_category = this.employeeUseInfo.profile.professional_filter_category
        this.areaOfSpecialization = this.employeeUseInfo.profile.professional_filter_name
        this.other_doctor_cat = this.employeeUseInfo.profile.professional_category
        setTimeout(()=>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode
            var phoneCountry = countrySplit.replace('+', '');
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
            }
        },100)
      }
      return
    }
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getUserInfoByIdFun
    this.SetIntialStatus
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    this.getProfessionCategoriesListMethods()
  },
  methods: {
    getProfessionCategoriesListMethods(){
      this.$store.dispatch('getMemberFilterListForSignupFun')
        .then((res) => {  
          this.memberAllFilterList = res.data.data
          if(this.memberAllFilterList){
            this.memberAllFilterListResults = this.memberAllFilterList.results
          }
        }).catch((err)=>{
        })
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              first_name:this.first_name,
              last_name:this.last_name,
              email:this.email,
              salutation:this.name_prefix_updated,
              professional_filter_category:this.professional_category,
              professional_filter_name:this.areaOfSpecialization,
              user_type:this.userRole
            }
            if(this.change_date != null && this.change_date != ''){
              data.change_date = this.change_date;
            }
            if(this.area_of_work != null && this.area_of_work != ''){
              data.area_of_work = this.area_of_work;
            }
            if(this.department != null && this.department != ''){
              data.department = this.department;
            }
            if(this.country != null && this.country != ''){
              data.country = this.country;
            }
            if(this.city != null && this.city != ''){
              data.city = this.city;
            }
            if(this.phone.countryCode != null && this.phone.countryCode != ''){
              data.mobile_country_code = '+' + this.phone.countryCode;
            }
            if(this.phone.number != null && this.phone.number != ''){
              data.mobile = this.phone.number;
            }
            if(this.other_doctor_cat != null && this.other_doctor_cat != ''){
              data.professional_category = this.other_doctor_cat;
            }
            this.$store.dispatch('updateEmployeeInfoFun', {data:{data: data, id: this.$route.params.employeeId}})
              .then((res) => {  
                  toast.success(res.data.msg);            
                  this.$router.push({ name: 'employeeList'})
              }).catch((err) => {
                toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    },
    titleChangedMethod(name, val){
      this.name_prefix = name
      if(val == 'Medical_Doctor'){
        this.name_prefix_updated = 'Dr'
      }else if(val == 'PhD_Doctor'){
        this.name_prefix_updated = 'Dr'
      }else{
        this.name_prefix_updated = val
      }
    },
    professionSelectCatFun(filterKey,filterCatVal,filterSubCatVal){
        this.professional_category = filterKey
        this.areaOfSpecialization = filterCatVal
        if(filterSubCatVal.length > 0){
          this.enabled_other_d_cat = true
          this.extraSubCatState = filterSubCatVal
        }else{
          this.enabled_other_d_cat = false
          this.other_doctor_cat = ''
        }
    },
    otherDoctorSelectCatFun(ODFilterVal){
      this.other_doctor_cat = ODFilterVal
    },
    userRoleChangesMethod(){
     this.change_date= ''
    }
  },
  watch: {
    getUserInfoByIdFun() {
      return this.$store.getters.orgUserDetailsByIdGetters.data
    },
    SetIntialStatus() {
     if(this.employeeUseInfo){
       this.first_name = this.employeeUseInfo.first_name
       this.last_name = this.employeeUseInfo.last_name
       this.name_prefix = this.employeeUseInfo.salutation ||  'Please Select'
       this.name_prefix_updated = this.employeeUseInfo.salutation || ''
       this.email = this.employeeUseInfo.email
       this.area_of_work = this.employeeUseInfo.profile.area_of_work
       this.department = this.employeeUseInfo.profile.department
       this.designation = this.employeeUseInfo.profile.designation
       this.division = this.employeeUseInfo.profile.division
       this.country = this.employeeUseInfo.profile.country.toLowerCase() || ''
       this.city = this.employeeUseInfo.profile.city
       this.activeStatus = this.employeeUseInfo.is_active
       this.userRole = this.employeeUseInfo.user_type || ''
       this.phone.countryCode = this.employeeUseInfo.profile.mobile_country_code  || '+91'
       this.phone.number = this.employeeUseInfo.profile.mobile
       this.professional_category = this.employeeUseInfo.profile.professional_filter_category
       this.areaOfSpecialization = this.employeeUseInfo.profile.professional_filter_name
       this.other_doctor_cat = this.employeeUseInfo.profile.professional_category
       setTimeout(()=>{
         if(this.phone.countryCode != null && this.phone.countryCode != ''){
           var countrySplit = this.phone.countryCode
           var phoneCountry = countrySplit.replace('+', '');
           this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
           }
       },100)
     }
     return
   }
  },
}